import { request } from '@src/utility/request'

export const genericSlots = async (params) => await request({
  method: 'get',
  url: '/generic/slots',
  params
})

export const getSports = async (params) => await request({
  method: 'get',
  url: '/generic/sport',
  params
})

export const getNewFields = async (params) => await request({
  method: 'get',
  url: '/generic/field/new',
  params
})

// TODO: pass orgId
export const genericVenues = async (orgId) => await request({
  method: 'get',
  url: '/generic/facility'
  // url: `/ generic / facilities / ${ orgId }`
})

export const genericVenue = async (moniker) => await request({
  method: 'get',
  url: `/generic/venue/${moniker}`
})

export const genericVenueFields = async (facilityId) => await request({
  method: 'get',
  url: `/generic/venue/fields/${facilityId}`
})

export const genericVenueSlots = async (params) => await request({
  method: 'get',
  url: '/generic/venue/slots',
  params
})

export const genericPrograms = async (params) => await request({
  method: 'get',
  url: '/generic/programs',
  params
})

export const genericOrgs = async () => await request({
  method: 'get',
  url: '/generic/genericOrgs'
})

export const getActivity = async (params) => await request({
  method: 'get',
  url: '/generic/activityLogs',
  params
})

export const getProgram = async (id) => await request({
  method: 'get',
  url: `/generic/program/${id}`
})

export const getOrgDetails = async (id) => await request({
  method: 'get',
  url: `/generic/org/${id}`
})

export const getConfig = async (key) => await request({
  method: 'get',
  url: `/generic/config/${key}`
})

export const getCities = async () => await request({
  method: 'get',
  url: '/generic/cities'
})

export const getActiveCities = async () => await request({
  method: 'get',
  url: '/generic/activeCities'
})

export const getExplore = async () => await request({
  method: 'get',
  url: '/generic/explore'
})

export const getEnrolPayDet = async (id) => await request({
  method: 'get',
  url: `/generic/enrolPayDet/${id}`
})

export const getBookPayDet = async (id) => await request({
  method: 'get',
  url: `/generic/bookPayDet/${id}`
})

export const getSubPayDet = async (id) => await request({
  method: 'get',
  url: `/generic/subPayDet/${id}`
})

export const postGRCaptcha = async (data) => await request({
  method: 'post',
  url: `/generic/grCaptcha/${data.action}`,
  data: data.token
})